import React from 'react';
import Badge from './Badge';
import { statusTone, type StatusDomain } from './status';

export interface StatusBadgeProps {
  domain: StatusDomain;
  status: string;
  /** Translated label shown in the badge. */
  label: React.ReactNode;
  size?: 'sm' | 'md';
  /** Leading dot (default true); turn it off when the label starts with its own icon. */
  dot?: boolean;
  className?: string;
}

/** Status pill whose colour comes from the shared status map. */
export default function StatusBadge({ domain, status, label, size, dot, className }: StatusBadgeProps) {
  return (
    <Badge tone={statusTone(domain, status)} size={size} dot={dot} className={className}>
      {label}
    </Badge>
  );
}
